<!--{{{ style -->
<style>
	@import '../assets/app.css';
	@import '../assets/festival.css';
	.edi-login {
		display: flex;
		-webkit-align-items: center;
		align-items: center;
		-webkit-justify-content: center;
		justify-content: center;
		flex-direction:column;
		color: #2c3e50;
		text-align: center;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.edi-login form {
		width: 100%;
		height: 400px;
	}
	.edi-login .fieldset-1 {
		/*margin-top: 6em !important;*/
		margin-top:100px !important;
	}
	.edi-login .fieldset-2 {
		margin-top: 1.175em;
	}
	.edi-login .logo {
		/*width: 126px;
		height: 156px;*/
		width: 35%;
	}
	.edi-login .footer-left,
	.edi-login .footer-right {
		color: #bebebe;
		text-decoration: none;
		/*position: absolute;*/
		bottom: 1em;
	}
	.edi-login .footer-left {
		left: 0;
	}
	.edi-login .footer-right {
		right: 0;
	}
	.login-page__top {
		width: 100%;
		height:60px;
	}
	.login-page__content {
		flex:1;
		width: 100%;
		display: flex;
		align-items: center;
	}
	.login-page__bottom {
		width: 100%;
		height:40px;
		position:relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.login-title {
		color: #269FA5
	}
</style>
<!--}}}-->
<!--{{{ template -->
<template>
	<div class="ui-content edi-login" id="loginForm">
		<div class="login-page__top"></div>
		<div class="login-page__content" >
			<form class="page-content__form" @submit.prevent="onSubmit" >
				<div class="logo-board">
					<img class="logo" :src="store.sysInfo && `${store.sysInfo.logo}?1`||''">
					<p style="font-size: 24px;" class="login-title fx-festival-color">{{store.sysInfo && store.sysInfo.name || '风行供货商EDI'}}</p>
				</div>

				<ul class="ui-listview ui-listview-inset fieldset-1">
					<li class="ui-listview-first-item"><input type="text" placeholder="账号/手机号" class="ui-align-center" v-model="mobile"/></li>
					<li class="ui-listview-last-item"><input type="password" placeholder="密码" class="ui-align-center" v-model="password"/></li>
				</ul>
				<fieldset class="ui-controlgroup fieldset-2" >
					<input type="submit" value="登录" class="submit fx-festival-btn-color" :class="{ 'ui-disable': submitDisable }"/>
				</fieldset>
			</form>
		</div>
		<div class="login-page__bottom">
			<router-link to="/forgot" class="footer-left">忘记密码?</router-link>
			<router-link to="/register" class="footer-right" v-if="store.sysInfo && (!store.sysInfo.showRegister || store.sysInfo.showRegister === '1')">新用户注册</router-link>
		</div>
		<!-- <router-link to="/forgot" class="footer-left">忘记密码?</router-link>
		<router-link to="/register" class="footer-right">新用户注册</router-link> -->
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<loading v-show="loading"></loading>
	</div>
</template>
<!--}}}-->
<!--{{{ script -->
<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import Config from '../configs'
import SysConfig from 'src/configs/SysConfig'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			loading: false,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 2,
			count: 0,
			tipsFont: '',
			mobile: '',
			password: '',
			enforce: false,
			loginData: {
				user: this.mobile,
				pass: this.password,
				enforce: this.enforce
			},
			exist: this.$route.query.exist,
			openId: this.$route.query.openId,
			transBillId: this.$route.query.transBillId,
			sessionstatus: this.$route.query.sessionstatus,
			store: GlobalStore,
			sec: 1500,
			state: 0,
			config: Config
		}
	},
	components: {
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	created () {
		this.checkConfig()
		// 对接登陆请求接口
		if (this.exist === 'true' && this.openId) {
			this.state = 1
			this.tips = true
			this.btnNum = 2
			this.tipsFont = '当前用户已登录，是否强行登录?'
		}
		if (this.sessionstatus === 'kickout') {
			this.tips = true
			this.btnNum = 1
			this.tipsFont = '你已被迫下线'
		} else if (this.sessionstatus === 'timeout') {
			this.tips = true
			this.btnNum = 1
			this.tipsFont = '登录超时'
		}
		this.$fxWeixin.registerWechatApi()
		this.initDefaultUserInfo()
	},
	computed: {
		submitDisable () {
			return !(this.mobile && this.password)
		}
	},
	methods: {
		initDefaultUserInfo () {
			const userName = window.localStorage.getItem('userName')
			var password = window.localStorage.getItem('encryptUserPass')

			if (userName) {
				this.mobile = userName
			}
			if (password) {
				this.password = this.$fxUtils.decrypt(password)
			}
		},
		checkConfig () {
			if (!this.store.sysInfo) {
				this.loading =
				SysConfig.getSysInfo().then(info => {
					window.document.title = info.name || Config.title
					if (!info.enable) {
						this.autoTips('该供货商EDI已停用')
					}
					this.store.sysInfo = info
					this.loading = false
				}).catch(() => {
					this.loading = false
				})
			}
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		onSubmit (e) {
			this.loading = true
			var loginData = {
				user: this.mobile,
				pass: this.password,
				enforce: this.enforce
			}
			this.$http.post('/cldEdi/business/loginByUserNameAndPassword', loginData).then((response) => {
				const encryptUserPass = this.$fxUtils.encrypt(loginData.pass)
				window.localStorage.setItem('userName', loginData.user)
				window.localStorage.setItem('encryptUserPass', encryptUserPass)

				this.loading = false
				var data = response.body
				if (!data.result) {
					if (data.data) {
						this.submitAgain()
					} else {
						this.autoTips(data.message)
					}
				} else {
					this.$router.push('/main/home')
					this.store.userInfo = data.data
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		submitAgain () {
			this.state = 0
			this.tips = true
			this.btnNum = 2
			this.tipsFont = '当前用户已登录，是否强行登录?'
		},
		submitCover () {
			var loginAgainData = {
				user: this.mobile,
				pass: this.password,
				enforce: true
			}
			this.$http.post('/cldEdi/business/loginByUserNameAndPassword', loginAgainData).then((response) => {
				this.$router.push('/main/home')
			})
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			if (this.msg[1] === true && this.state === 0) {
				this.submitCover()
				return false
			}
			if (this.msg[1] === true && this.state === 1) {
				this.logIn()
				return false
			}
		},
		logIn () {
			this.tips = false
			var openid = {
				openId: this.openId
			}
			this.$http.post('/cldEdi/business/enforceByOpenId', openid).then((response) => {
				if (this.transBillId === undefined) {
					this.$router.push('/main/home')
				} else {
					this.$router.push('detail-bill?trans_bill_id=' + this.transBillId)
				}
			})
		}
		// keyboardBounce (isClose) {
		// 	var keyboard = this.$refs.keyboard
		// 	var timer = setInterval(function () {
		// 		keyboard.scrollIntoView(true)
		// 		if (isClose) {
		// 			clearInterval(timer)
		// 			const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
		// 			window.scrollTo({
		// 				top: scrollHeight
		// 			})
		// 		}
		// 	}, 500)
		// }
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Login.vue?4469d944